// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eoCkyEykF6XbSP {
  min-width: 120px;
  margin: var(--ds-space-050, 4px);
}
.AERztrG_U1tZNM {
  box-sizing: border-box;
}
.AERztrG_U1tZNM a {
  outline: none;
}
._Twap9hwURo2oB {
  outline-offset: var(--ds-space-025, 2px);
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac ._Twap9hwURo2oB {
  outline-color: -webkit-focus-ring-color;
}
._Twap9hwURo2oB .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
export var boardSwitcherTile = `eoCkyEykF6XbSP`;
export var boardSwitcherListTile = `AERztrG_U1tZNM`;
export var activeBoardTile = `_Twap9hwURo2oB`;
export default ___CSS_LOADER_EXPORT___;
